import { Templates } from "../../ui/Templates";
import { userAccountDg } from "../../ui/templates/userAccountTemplates";
import { UserManager, UserManagerEvent, UserManagerEventType }
	from "../UserManager";

export class UserAccountDialog {
	private _ui:HTMLDivElement;
	private _accountPanel:HTMLDivElement;
	
	private _userManager:UserManager;
	
	private _finishedResolver: () => void;
	
	constructor(){
		this._init();
	}
	
	public show():Promise<void> {
		return new Promise(async (resolve, reject):Promise<void> => {
			this._addListeners();
			this._finishedResolver = resolve;
			
			document.body.append(this._ui);
			await this._userManager.activate(true);
			this._userManager.show();
			
			
		});
		
	}
	
	private async _init():Promise<void> {
		this._createUi();
		this._userManager = UserManager.get(this._accountPanel);
	}
	
	private _createUi():void {
		this._ui = Templates.createDiv(userAccountDg);
		this._accountPanel = this._ui.querySelector("#stscr-account");
		
	}
	
	private _onUserManagerEvent = (e:UserManagerEvent):void => {
		switch(e.type){
			case UserManagerEventType.sessionFinished:
				this._finish();
				break;
		}
	}
	
	private _finish():void {
		this._userManager.deactivate();
		
		this._removeListeners();
		this._ui.remove();
		
		this._finishedResolver();
	}
	
	private _addListeners():void {
		this._removeListeners();
		
		this._userManager.event.on(this._onUserManagerEvent);
	}
	
	private _removeListeners():void {
		this._userManager.event.off(this._onUserManagerEvent);
	}
}

export class UserAccountDialogEvent {
	public type:UserAccountDialogEventType;
}

export enum UserAccountDialogEventType {
	finished
}